import React, { PropTypes } from "react";
import ComponentRegistry from "Fratello/Common/ComponentRegistry";

import StepperController from "../../../../../../../src-js/Fratello/Common/Controllers/StepperController";

export default function BasketItemView({ item, labels, onUpdate, onRemove }) {
    const Image = ComponentRegistry.get("Image");
    const DeleteButton = ComponentRegistry.get("DeleteButton");
    const Price = ComponentRegistry.get("Price");

    const product = item.product;
    const features = item.personalisedProperties
        .concat(Object.values(product.data.distinguishing_properties))
        .slice(0, 3)
        .map(
            property =>  <div className="col-xs-6" key={`property-${property.name}`}><h3 className="item-subtitle">{property.name}</h3><div className="item-property">{property.value}</div></div>,
        );

    return (
        <div className="basket-item list-item">
            <div className="row">
                <div className="col-lg-1 column">
                    <a href onClick={() => onRemove()} className="item-action"><i className="icon icon-remove"></i><span className="sr-only">{labels.remove}</span></a>
                </div>
                <div className="col-lg-1 column item-visual text-left">
                    {typeof product.image === 'undefined' || null === product.image ? (<span className="item-placeholder"><i className="icon icon-basket icon-xl"></i></span>) : <Image src={product.image} url={product.url} name={product.name} /> }
                </div>
                <div className="col-lg-2 column">{product.sku}</div>
                <div className="col-lg-3 column">
                    <span className="text-wrapper"><a href={product.url}>{product.name}</a></span>
                </div>
                <div className="col-lg-1 column">{item.pricingPerUnit.excl}</div>
                <div className="col-lg-2 column">
                    <StepperController
                        value={item.quantity}
                        onChange={value => onUpdate({ quantity: value })}
                        min={item.product.minimumPurchaseAmount}
                        step={item.product.multipleFactor}
                    />
                </div>
                <div className="col-lg-1 column"><Price value={item.pricing.excl} /></div>
                <div className="col-lg-1 column text-right">
                    <span className={product.data.stock_type === 'onorder' ? 'incentive incentive-danger' : 'incentive incentive-success'}>{product.data.stock_type}</span>
                </div>
            </div>
        </div>
    );
}

BasketItemView.propTypes = {
    item: PropTypes.shape({
        quantity: PropTypes.number,
        product: PropTypes.shape({
            url: PropTypes.string,
            name: PropTypes.string,
            minimumPurchaseAmount: PropTypes.number,
            multipleFactor: PropTypes.number,
            pricing: PropTypes.shape({
                price: PropTypes.string,
            }),
        }),
        pricing: PropTypes.shape({
            excl: PropTypes.string,
        }),
    }),
    labels: PropTypes.shape({
        sku: PropTypes.string,
        price_per: PropTypes.string.isRequired,
        remove: PropTypes.string,
    }),
    onRemove: PropTypes.func,
    onUpdate: PropTypes.func,
};

BasketItemView.defaultProps = {
    labels: {},
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/Basket/Views/BasketItemView.jsx